import 'material-design-icons-iconfont/dist/material-design-icons.css';

import '@/registerServiceWorker';
import '@/scss/main.scss';
import '@/plugins/google-maps';

import Vue from 'vue';

import { options } from '@/plugins/vuetify';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import i18n from '@/plugins/i18n';
import axios from 'axios';
import Vuetify from 'vuetify';

Vue.config.productionTip = false;

const renderApp = async () => {
  let theme;
  try {
    theme = await axios.get('api/info/theme').then((response) => response.data);
  } catch (e) {
    console.log('Error loading theme..');
    console.error(e);
  }
  if (theme) {
    options.theme.themes.light = theme;
  }

  const vuetify = new Vuetify(options);
  new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
};

renderApp();
